(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-bundle-buybox"] && !Shopify.designMode) return;
  try {
    
  /**
   * PayPal Express Button Web Component
   * Adds product to cart and redirects to checkout
   */
  if (!customElements.get('td-paypal-express-button')) {
    class TdPaypalExpressButton extends HTMLElement {
      constructor() {
        super();
        this.button = null;
        this.variantId = null;
        this.boundHandleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.variantId = this.getAttribute('data-variant-id');
        this.initializeButton();
      }

      initializeButton() {
        this.button = this.querySelector('button');
        if (this.button) {
          this.button.addEventListener('click', this.boundHandleClick);
        }
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.boundHandleClick);
        }
      }

      async handleClick(event) {
        event.preventDefault();

        this.variantId = this.getAttribute('data-variant-id');
        if (!this.variantId || this.button.disabled) {
          return;
        }

        this.button.disabled = true;
        this.button.style.opacity = '0.7';

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: this.variantId,
                quantity: 1
              }]
            })
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          window.location.href = window.Shopify.routes.root + 'checkout';
        } catch (error) {
          console.error('PayPal Express error:', error);
          this.button.disabled = false;
          this.button.style.opacity = '1';
        }
      }
    }

    customElements.define('td-paypal-express-button', TdPaypalExpressButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-lp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-smooth-scroll-link')) {
    class TdSmoothScrollLink extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-td-smooth-scroll-link]');
        if (!this.link) {
          return;
        }

        this.boundHandleClick = this.handleClick.bind(this);
        this.link.addEventListener('click', this.boundHandleClick);
      }

      disconnectedCallback() {
        if (this.link && this.boundHandleClick) {
          this.link.removeEventListener('click', this.boundHandleClick);
        }
      }

      handleClick(event) {
        const href = this.link?.getAttribute('href') || '';
        if (!href.startsWith('#')) {
          return;
        }

        const target = document.querySelector(href);
        if (!target) {
          return;
        }

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });

        history.pushState(null, '', href);
      }
    }

    customElements.define('td-smooth-scroll-link', TdSmoothScrollLink);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-main-product"]) return;
  try {
    
  if (!customElements.get("td-color-badges")) {
    customElements.define(
      "td-color-badges",
      class TDColorBadges extends HTMLElement {
        connectedCallback() {
          this.badges = Array.from(
            this.querySelectorAll(".td-color-badge[data-variant-id]")
          );

          if (!this.badges.length) return;

          this.productInfo = this.closest("product-info");
          this.variantElement = this.productInfo
            ? this.productInfo.querySelector("variant-radios, variant-selects")
            : null;
          this.variantInput = this.productInfo
            ? this.productInfo.querySelector(".product-variant-id")
            : null;
          this.sectionElement = this.closest("section");
          this.mediaGalleryResponsive = this.sectionElement
            ? this.sectionElement.querySelector("product-media-gallery-responsive")
            : null;
          this.gallerySwiperElement = this.mediaGalleryResponsive
            ? this.mediaGalleryResponsive.querySelector(".product-media-gallery")
            : null;

          this.onBadgeClick = this.onBadgeClick.bind(this);
          this.onVariantInputChange = this.onVariantInputChange.bind(this);
          this.onVariantPickerChange = this.onVariantPickerChange.bind(this);

          this.badges.forEach((badge) => {
            badge.addEventListener("click", this.onBadgeClick);
          });

          if (this.variantInput) {
            this.variantInput.addEventListener("change", this.onVariantInputChange);
            this.updateActiveBadge(this.variantInput.value);
          }

          if (this.variantElement) {
            this.variantElement.addEventListener("change", this.onVariantPickerChange);
          }
        }

        disconnectedCallback() {
          if (!this.badges || !this.badges.length) return;

          this.badges.forEach((badge) => {
            badge.removeEventListener("click", this.onBadgeClick);
          });

          if (this.variantInput) {
            this.variantInput.removeEventListener(
              "change",
              this.onVariantInputChange
            );
          }

          if (this.variantElement) {
            this.variantElement.removeEventListener(
              "change",
              this.onVariantPickerChange
            );
          }
        }

        onBadgeClick(event) {
          const targetBadge = event.currentTarget;
          const variantId = targetBadge && targetBadge.dataset.variantId;

          if (!variantId) return;

          const selectedVariant = this.getVariantById(variantId);
          this.selectVariantById(variantId);
          this.updateActiveBadge(variantId);
          this.setActiveMediaForVariant(selectedVariant, targetBadge);
        }

        onVariantInputChange(event) {
          if (!event.target || !event.target.value) return;
          const variantId = event.target.value;
          const activeBadge = this.getBadgeByVariantId(variantId);
          this.updateActiveBadge(variantId);
          this.setActiveMediaForVariant(this.getVariantById(variantId), activeBadge);
        }

        onVariantPickerChange() {
          requestAnimationFrame(() => {
            if (this.variantInput && this.variantInput.value) {
              const variantId = this.variantInput.value;
              const activeBadge = this.getBadgeByVariantId(variantId);
              this.updateActiveBadge(variantId);
              this.setActiveMediaForVariant(
                this.getVariantById(variantId),
                activeBadge
              );
            }
          });
        }

        selectVariantById(variantId) {
          if (!this.variantElement) return;

          const variantData = this.getVariantData();
          const selectedVariant = variantData.find(
            (variant) => String(variant.id) === String(variantId)
          );

          if (!selectedVariant || !Array.isArray(selectedVariant.options)) return;

          if (this.variantElement.tagName === "VARIANT-RADIOS") {
            this.selectRadioVariant(selectedVariant.options);
            return;
          }

          this.selectDropdownVariant(selectedVariant.options);
        }

        getVariantById(variantId) {
          if (!variantId) return null;
          return (
            this.getVariantData().find(
              (variant) => String(variant.id) === String(variantId)
            ) || null
          );
        }

        getBadgeByVariantId(variantId) {
          if (!variantId) return null;
          return (
            this.badges.find(
              (badge) => String(badge.dataset.variantId) === String(variantId)
            ) || null
          );
        }

        selectRadioVariant(optionValues) {
          const fieldsets = Array.from(this.variantElement.querySelectorAll("fieldset"));
          let changedInput = null;

          fieldsets.forEach((fieldset, index) => {
            const optionValue = optionValues[index];
            if (optionValue === undefined) return;

            const inputs = Array.from(fieldset.querySelectorAll("input[type='radio']"));
            const targetInput = inputs.find((input) => input.value === optionValue);

            if (!targetInput || targetInput.checked) return;

            targetInput.checked = true;
            changedInput = targetInput;
          });

          if (changedInput) {
            changedInput.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }

        selectDropdownVariant(optionValues) {
          const selects = Array.from(this.variantElement.querySelectorAll("select"));
          let changedSelect = null;

          selects.forEach((select, index) => {
            const optionValue = optionValues[index];
            if (optionValue === undefined || select.value === optionValue) return;

            select.value = optionValue;
            changedSelect = select;
          });

          if (changedSelect) {
            changedSelect.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }

        getVariantData() {
          if (this.variantData) return this.variantData;

          const variantJson = this.variantElement
            ? this.variantElement.querySelector("script[type='application/json']")
            : null;

          if (!variantJson) {
            this.variantData = [];
            return this.variantData;
          }

          try {
            this.variantData = JSON.parse(variantJson.textContent);
          } catch (error) {
            this.variantData = [];
          }

          return this.variantData;
        }

        setActiveMediaForVariant(variant, badgeElement = null, attempt = 0) {
          if (!this.gallerySwiperElement) return;

          const swiperContainer = this.gallerySwiperElement;
          const swiperInstance = swiperContainer.swiper;

          // Swiper can initialize slightly after interaction on some PDP loads.
          if (!swiperInstance) {
            if (attempt >= 5) return;
            setTimeout(
              () => this.setActiveMediaForVariant(variant, badgeElement, attempt + 1),
              120
            );
            return;
          }

          let slideIndex = null;
          const featuredMedia = variant ? variant.featured_media || variant.featured_image : null;

          if (featuredMedia && featuredMedia.position) {
            slideIndex = Number(featuredMedia.position) - 1;
          }

          if ((slideIndex === null || Number.isNaN(slideIndex)) && featuredMedia && featuredMedia.id) {
            const slides = Array.from(swiperContainer.querySelectorAll("swiper-slide"));
            slideIndex = slides.findIndex((slide) =>
              slide.querySelector(`[data-media-id="${featuredMedia.id}"]`)
            );
          }

          // Fallback for setups where color entry image is not attached as variant featured media.
          if (slideIndex === null || Number.isNaN(slideIndex) || slideIndex < 0) {
            slideIndex = this.getSlideIndexFromBadgeData(swiperContainer, badgeElement);
          }

          if (slideIndex === null || slideIndex < 0) return;

          if (typeof swiperInstance.slideToLoop === "function") {
            swiperInstance.slideToLoop(slideIndex);
            return;
          }

          if (typeof swiperInstance.slideTo === "function") {
            swiperInstance.slideTo(slideIndex);
          }
        }

        getSlideIndexFromBadgeData(swiperContainer, badgeElement) {
          if (!badgeElement) return -1;

          const slides = Array.from(swiperContainer.querySelectorAll("swiper-slide"));
          const badgeImage = badgeElement.dataset.badgeImage || "";
          const badgeColorName = (badgeElement.dataset.colorName || "").trim().toLowerCase();
          const badgeFileName = this.getFileNameFromUrl(badgeImage);

          if (badgeFileName) {
            const imageMatchIndex = slides.findIndex((slide) =>
              Array.from(slide.querySelectorAll("img")).some((img) => {
                const imageFileName = this.getFileNameFromUrl(img.currentSrc || img.src || "");
                return imageFileName === badgeFileName;
              })
            );

            if (imageMatchIndex >= 0) return imageMatchIndex;
          }

          if (badgeColorName) {
            const altMatchIndex = slides.findIndex((slide) =>
              Array.from(slide.querySelectorAll("img")).some((img) =>
                (img.alt || "").toLowerCase().includes(badgeColorName)
              )
            );

            if (altMatchIndex >= 0) return altMatchIndex;
          }

          return -1;
        }

        getFileNameFromUrl(url) {
          if (!url) return "";

          let pathname = "";
          try {
            pathname = new URL(url, window.location.origin).pathname;
          } catch (error) {
            pathname = url.split("?")[0];
          }

          const fileName = pathname.split("/").pop() || "";
          return decodeURIComponent(fileName).toLowerCase();
        }

        updateActiveBadge(variantId) {
          this.badges.forEach((badge) => {
            badge.classList.toggle(
              "td-color-badge--active",
              String(badge.dataset.variantId) === String(variantId)
            );
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
